import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import {Fab, withStyles} from "@material-ui/core";
import styles from "./styles";
import ImgPoi from "./poi/ImgPoi";
import classNames from "classnames";
import {Link} from "react-router-dom";
import {ReactComponent as GoogleMapIcon} from "../../assets/images/icons/google-maps.svg";
import {ReactComponent as ScrollIcon} from "../../assets/images/icons/scroll.svg";

const PoiOnMap = ({classes, data}) => {
	const imgRef = useRef();
	const contentRef = useRef();
	const poiRef = useRef();
	const [dimensions, setDimensions] = useState();
	const [originalWidth, setOriginalWidth] = useState();
	const [originalHeight, setOriginalHeight] = useState();
	const [currentWidth, setCurrentWidth] = useState();
	const [currentHeight, setCurrentHeight] = useState();
	const [isOpenScrollMessage, setIsOpenScrollMessage] = useState(false);

	useEffect(() => {
		const newImage = new Image();
		newImage.src = window.location.origin + "/data/district/main.jpg";
		newImage.onload = function () {
			const width = this.naturalWidth;
			const height = this.naturalHeight;
			setOriginalWidth(width);
			setOriginalHeight(height);

			if (window.innerWidth <= 960) {
				contentRef.current.scrollTo({
					top: ((height / 2) - (window.innerHeight / 2)),
					left: ((width / 2) - (window.innerWidth / 2))
				});
				let showMessage = localStorage.getItem("scroll_message");
				if (!showMessage) {
					setIsOpenScrollMessage(true);
					localStorage.setItem("scroll_message", 1);
				}
			}
		}
		window.addEventListener("resize", handleResize, false);
		return () => {
			window.removeEventListener("resize", handleResize, true);
		}
	}, []);

	useEffect(() => {
		setTimeout(() => {
			setIsOpenScrollMessage(false)
		}, 3000);
	}, [isOpenScrollMessage])

	useEffect(() => {
		setOriginalWidth(imgRef.current.naturalWidth);
		setOriginalHeight(imgRef.current.naturalHeight);
		setCurrentWidth(imgRef.current.clientWidth);
		setCurrentHeight(imgRef.current.clientHeight);
	}, [dimensions]);

	const handleResize = () => {
		setDimensions({
			width: window.innerWidth,
			height: window.innerHeight
		});
	};


	return (
		<>
			<div className={classNames(classes.scrollIcon, isOpenScrollMessage ? classes.scrollShow : classes.scrollHide)}>
				<span>Déplacez la carte en restant appuyé afin d'accéder à tous les points</span>
				<ScrollIcon/>
			</div>
			<div className={classes.districtMode} ref={contentRef}>
				<Fab
					className={classNames(classes.btnBack)}
					component={Link}
					to="/"
					variant="extended"
				>
					<GoogleMapIcon
						className={classNames(
							classes.primaryColor,
							classes.googleMapIcon
						)}
					/>


					{"VUE 3D"}
				</Fab>
				<div style={{height: "100%"}}>
					<img
						ref={imgRef}
						src={window.location.origin + "/data/district/main.jpg"}
					/>
				</div>
				{data.map(item => (
					<ImgPoi
						ref={poiRef}
						key={`img-${item.id}`}
						poi={item}
						originalWidth={originalWidth}
						originalHeight={originalHeight}
						currentWidth={currentWidth}
						currentHeight={currentHeight}
					/>
				))}
			</div>
		</>
	);
};
PoiOnMap.propTypes = {
	classes: PropTypes.object.isRequired
};
export default withStyles(styles)(PoiOnMap);
